@if (store.asArray(); as notifications) {
  <p-table
    #notificationTable
    [globalFilterFields]="['name']"
    [paginator]="notifications.length > 10"
    [rows]="10"
    [rowsPerPageOptions]="[10, 20, 50]"
    [loading]="loading"
    [value]="notifications">
    <ng-template pTemplate="caption">
      <app-table-list-caption
        [searchWord]="searchWord"
        (clearTable)="clear(notificationTable)"
        (search)="
          notificationTable.filterGlobal($event, 'contains')
        "></app-table-list-caption>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th></th>
        <th>Name</th>
        <th>Aktionen</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-notification>
      <tr>
        <td>
          <i
            class="fas"
            [class]="notification.locked ? 'fa-locked' : 'fa-check-circle'"></i>
        </td>
        <td>
          <span class="flex align-items-center gap-3"
            ><i class="fas fa-bell"></i> {{ notification.title }}</span
          >
        </td>
        <td>
          <button
            pButton
            [rounded]="true"
            class="p-button-rounded p-button-xs p-button-primary mr-2"
            icon="fas fa-unlock"></button>

          <app-table-list-actions
            [item]="notification"
            (confirm)="confirm($event, notification, notification.name)">
          </app-table-list-actions>
        </td>
      </tr>
    </ng-template>
  </p-table>
} @else {
  <div role="alert" class="p-message p-message-info">
    <div class="p-message-wrapper">
      <span class="p-message-summary">404</span>
      <span class="p-message-detail">Keine Nachrichten gefunden</span>
    </div>
  </div>
}

<p-sidebar
  (onHide)="onOverlayClose()"
  position="right"
  [modal]="false"
  [styleClass]="'w-7'"
  [visible]="editFormOverlay">
  <ng-template pTemplate="header">
    <app-header
      [icon]="editFormOverlayIcon"
      [text]="editFormOverlayHeader"></app-header
  ></ng-template>

  <ng-container *ngIf="editFormOverlay">
    <router-outlet name="bearbeiten"></router-outlet>
  </ng-container>
</p-sidebar>
<app-mask [visible]="editFormOverlay" (click)="onOverlayClose()"></app-mask>
